module.exports = __webpack_public_path__ + "img/icon-activities.ca219691.svg";